import Nullstack from 'nullstack';
export default function IconBarrierBlockOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-barrier-block-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 7h8a1 1 0 0 1 1 1v7c0 .27 -.107 .516 -.282 .696"
  }), "   ", Nullstack.element("path", {
    d: "M16 16h-11a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h2"
  }), "   ", Nullstack.element("path", {
    d: "M7 16v4"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 16l4.244 -4.244"
  }), "   ", Nullstack.element("path", {
    d: "M13.745 9.755l2.755 -2.755"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 16l1.249 -1.249"
  }), "   ", Nullstack.element("path", {
    d: "M16.741 12.759l3.259 -3.259"
  }), "   ", Nullstack.element("path", {
    d: "M4 13.5l4.752 -4.752"
  }), "   ", Nullstack.element("path", {
    d: "M17 17v3"
  }), "   ", Nullstack.element("path", {
    d: "M5 20h4"
  }), "   ", Nullstack.element("path", {
    d: "M15 20h4"
  }), "   ", Nullstack.element("path", {
    d: "M17 7v-2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}